export default {"src":"/_next/static/media/light-mode-icon-uncollapsed.08d7b306.svg","height":186,"width":1285,"blurWidth":0,"blurHeight":0};